import { useState, useEffect, useRef } from "react";

// ============================================================
// MEDSHARE - Ecossistema Médico
// ============================================================

// --- ICONS (inline SVG components) ---
const Icons = {
  Logo: ({ size = 32 }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
      <rect width="40" height="40" rx="10" fill="url(#logoGrad)" />
      <path d="M12 20h16M20 12v16" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
      <path d="M14 14l4 4m4-4l4 4m-12 4l4 4m4-4l4 4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
      <defs>
        <linearGradient id="logoGrad" x1="0" y1="0" x2="40" y2="40">
          <stop stopColor="#0D9488" />
          <stop offset="1" stopColor="#065F46" />
        </linearGradient>
      </defs>
    </svg>
  ),
  Laser: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="3" /><path d="M12 2v4m0 12v4M2 12h4m12 0h4m-3.5-7.5l-2.8 2.8m-5.4 5.4l-2.8 2.8m0-11l2.8 2.8m5.4 5.4l2.8 2.8" />
    </svg>
  ),
  Book: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
    </svg>
  ),
  Cart: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
    </svg>
  ),
  Search: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
    </svg>
  ),
  Star: ({ filled }) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill={filled ? "#f59e0b" : "none"} stroke="#f59e0b" strokeWidth="2">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  ),
  User: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Calendar: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  ),
  MapPin: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" />
    </svg>
  ),
  Shield: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  TrendingUp: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M23 6l-9.5 9.5-5-5L1 18" /><path d="M17 6h6v6" />
    </svg>
  ),
  Clock: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
    </svg>
  ),
  ChevronRight: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M9 18l6-6-6-6" />
    </svg>
  ),
  Check: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),
  Heart: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
    </svg>
  ),
  Menu: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M3 12h18M3 6h18M3 18h18" />
    </svg>
  ),
  X: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  ),
  Bell: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 01-3.46 0" />
    </svg>
  ),
  Award: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="8" r="7" /><path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12" />
    </svg>
  ),
  Camera: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" /><circle cx="12" cy="13" r="4" />
    </svg>
  ),
  Play: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M8 5v14l11-7z" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  ),
  Grid: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
    </svg>
  ),
  DollarSign: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
    </svg>
  ),
};

// --- STYLES ---
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Outfit:wght@300;400;500;600;700;800;900&display=swap');

  :root {
    --teal-50: #f0fdfa;
    --teal-100: #ccfbf1;
    --teal-200: #99f6e4;
    --teal-300: #5eead4;
    --teal-400: #2dd4bf;
    --teal-500: #14b8a6;
    --teal-600: #0d9488;
    --teal-700: #0f766e;
    --teal-800: #115e59;
    --teal-900: #134e4a;
    --emerald-600: #059669;
    --emerald-700: #047857;
    --slate-50: #f8fafc;
    --slate-100: #f1f5f9;
    --slate-200: #e2e8f0;
    --slate-300: #cbd5e1;
    --slate-400: #94a3b8;
    --slate-500: #64748b;
    --slate-600: #475569;
    --slate-700: #334155;
    --slate-800: #1e293b;
    --slate-900: #0f172a;
    --amber-500: #f59e0b;
    --red-500: #ef4444;
    --font-display: 'Outfit', sans-serif;
    --font-body: 'Plus Jakarta Sans', sans-serif;
  }

  * { margin: 0; padding: 0; box-sizing: border-box; }
  
  body { font-family: var(--font-body); color: var(--slate-800); background: var(--slate-50); }

  .ms-app { min-height: 100vh; overflow-x: hidden; }

  /* ---- NAVBAR ---- */
  .ms-nav {
    position: sticky; top: 0; z-index: 100;
    background: rgba(255,255,255,0.92); backdrop-filter: blur(20px);
    border-bottom: 1px solid var(--slate-200);
    padding: 0 2rem; height: 72px;
    display: flex; align-items: center; justify-content: space-between;
  }
  .ms-nav-logo { display: flex; align-items: center; gap: 10px; cursor: pointer; }
  .ms-nav-logo h1 {
    font-family: var(--font-display); font-weight: 800; font-size: 1.5rem;
    background: linear-gradient(135deg, var(--teal-700), var(--teal-500));
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
  }
  .ms-nav-links { display: flex; align-items: center; gap: 2rem; }
  .ms-nav-link {
    font-size: 0.9rem; font-weight: 500; color: var(--slate-600);
    cursor: pointer; transition: all 0.2s; position: relative; padding: 4px 0;
    background: none; border: none; font-family: var(--font-body);
  }
  .ms-nav-link:hover, .ms-nav-link.active { color: var(--teal-700); }
  .ms-nav-link.active::after {
    content: ''; position: absolute; bottom: -2px; left: 0; right: 0;
    height: 2px; background: var(--teal-600); border-radius: 1px;
  }
  .ms-nav-actions { display: flex; align-items: center; gap: 1rem; }
  .ms-nav-bell { position: relative; cursor: pointer; color: var(--slate-500); background:none; border:none; }
  .ms-nav-bell-dot {
    position: absolute; top: 0; right: 0; width: 8px; height: 8px;
    background: var(--red-500); border-radius: 50%; border: 2px solid #fff;
  }
  .ms-nav-avatar {
    width: 40px; height: 40px; border-radius: 12px; cursor: pointer;
    background: linear-gradient(135deg, var(--teal-400), var(--teal-600));
    display: flex; align-items: center; justify-content: center; color: #fff;
    font-weight: 700; font-size: 0.85rem; font-family: var(--font-display);
  }
  .ms-mobile-toggle { display: none; background: none; border: none; color: var(--slate-700); cursor: pointer; }

  /* ---- BUTTONS ---- */
  .ms-btn {
    display: inline-flex; align-items: center; gap: 8px;
    font-family: var(--font-body); font-weight: 600; font-size: 0.9rem;
    padding: 12px 24px; border-radius: 12px; cursor: pointer;
    transition: all 0.25s; border: none; text-decoration: none;
  }
  .ms-btn-primary {
    background: linear-gradient(135deg, var(--teal-600), var(--emerald-700));
    color: #fff; box-shadow: 0 4px 14px rgba(13,148,136,0.35);
  }
  .ms-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(13,148,136,0.45); }
  .ms-btn-secondary {
    background: #fff; color: var(--teal-700);
    border: 2px solid var(--teal-200);
  }
  .ms-btn-secondary:hover { border-color: var(--teal-400); background: var(--teal-50); }
  .ms-btn-ghost { background: transparent; color: var(--slate-600); }
  .ms-btn-ghost:hover { background: var(--slate-100); }
  .ms-btn-sm { padding: 8px 16px; font-size: 0.82rem; border-radius: 10px; }
  .ms-btn-lg { padding: 16px 32px; font-size: 1rem; border-radius: 14px; }

  /* ---- HERO ---- */
  .ms-hero {
    position: relative; overflow: hidden;
    background: linear-gradient(160deg, var(--slate-900) 0%, var(--teal-900) 50%, var(--emerald-700) 100%);
    min-height: 92vh; display: flex; align-items: center;
    padding: 6rem 2rem;
  }
  .ms-hero::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse at 70% 20%, rgba(20,184,166,0.15) 0%, transparent 60%),
                radial-gradient(ellipse at 30% 80%, rgba(5,150,105,0.1) 0%, transparent 50%);
  }
  .ms-hero-grid {
    position: absolute; inset: 0; opacity: 0.04;
    background-image: linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px),
                      linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px);
    background-size: 60px 60px;
  }
  .ms-hero-content {
    position: relative; max-width: 1200px; margin: 0 auto; width: 100%;
    display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center;
  }
  .ms-hero-text { animation: fadeUp 0.8s ease-out; }
  .ms-hero-badge {
    display: inline-flex; align-items: center; gap: 8px;
    background: rgba(20,184,166,0.15); border: 1px solid rgba(20,184,166,0.3);
    padding: 6px 16px; border-radius: 100px; font-size: 0.8rem;
    color: var(--teal-300); font-weight: 600; margin-bottom: 1.5rem;
  }
  .ms-hero-badge-dot { width: 6px; height: 6px; background: var(--teal-400); border-radius: 50%; animation: pulse 2s infinite; }
  .ms-hero h2 {
    font-family: var(--font-display); font-size: 3.8rem; font-weight: 900;
    line-height: 1.08; color: #fff; margin-bottom: 1.5rem;
    letter-spacing: -0.03em;
  }
  .ms-hero h2 span {
    background: linear-gradient(135deg, var(--teal-300), var(--teal-400));
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
  }
  .ms-hero-sub {
    font-size: 1.15rem; color: rgba(255,255,255,0.65); line-height: 1.7;
    max-width: 480px; margin-bottom: 2.5rem;
  }
  .ms-hero-btns { display: flex; gap: 1rem; flex-wrap: wrap; }
  .ms-hero-stats {
    display: flex; gap: 3rem; margin-top: 3rem;
    padding-top: 2rem; border-top: 1px solid rgba(255,255,255,0.1);
  }
  .ms-hero-stat-num {
    font-family: var(--font-display); font-size: 2rem; font-weight: 800; color: #fff;
  }
  .ms-hero-stat-label { font-size: 0.8rem; color: rgba(255,255,255,0.45); margin-top: 4px; }

  .ms-hero-visual {
    position: relative; display: flex; justify-content: center;
    animation: fadeUp 0.8s ease-out 0.2s both;
  }
  .ms-hero-card {
    background: rgba(255,255,255,0.06); backdrop-filter: blur(20px);
    border: 1px solid rgba(255,255,255,0.1); border-radius: 24px;
    padding: 2rem; width: 100%; max-width: 420px;
  }
  .ms-hero-card-header { display: flex; justify-content: space-between; align-items: start; margin-bottom: 1.5rem; }
  .ms-hero-card-title { color: #fff; font-weight: 700; font-size: 1.1rem; }
  .ms-hero-card-sub { color: rgba(255,255,255,0.5); font-size: 0.82rem; margin-top: 4px; }
  .ms-hero-card-badge-live {
    background: rgba(239,68,68,0.2); color: #fca5a5; padding: 4px 12px;
    border-radius: 100px; font-size: 0.75rem; font-weight: 600;
    display: flex; align-items: center; gap: 6px;
  }
  .ms-hero-card-badge-dot { width: 6px; height: 6px; background: #ef4444; border-radius: 50%; animation: pulse 1.5s infinite; }
  .ms-hero-card-items { display: flex; flex-direction: column; gap: 12px; }
  .ms-hero-card-item {
    background: rgba(255,255,255,0.05); border-radius: 14px; padding: 14px;
    display: flex; justify-content: space-between; align-items: center;
    border: 1px solid rgba(255,255,255,0.06);
  }
  .ms-hero-card-item-name { color: #fff; font-weight: 600; font-size: 0.88rem; }
  .ms-hero-card-item-detail { color: rgba(255,255,255,0.4); font-size: 0.78rem; margin-top: 2px; }
  .ms-hero-card-item-price { color: var(--teal-300); font-weight: 700; font-size: 0.95rem; }
  .ms-hero-card-item-period { color: rgba(255,255,255,0.35); font-size: 0.7rem; }

  /* ---- SECTIONS ---- */
  .ms-section {
    padding: 6rem 2rem;
    max-width: 1200px; margin: 0 auto;
  }
  .ms-section-header { text-align: center; margin-bottom: 4rem; }
  .ms-section-tag {
    display: inline-flex; align-items: center; gap: 6px;
    color: var(--teal-600); font-weight: 700; font-size: 0.8rem;
    text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 1rem;
  }
  .ms-section-title {
    font-family: var(--font-display); font-size: 2.8rem; font-weight: 800;
    color: var(--slate-900); letter-spacing: -0.02em; line-height: 1.15;
  }
  .ms-section-desc {
    color: var(--slate-500); font-size: 1.05rem; max-width: 600px;
    margin: 1rem auto 0; line-height: 1.7;
  }

  /* ---- VERTICALS (3 pillars) ---- */
  .ms-verticals { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; }
  .ms-vertical-card {
    background: #fff; border-radius: 20px; padding: 2.5rem;
    border: 1px solid var(--slate-200); transition: all 0.3s;
    cursor: pointer; position: relative; overflow: hidden;
  }
  .ms-vertical-card:hover { border-color: var(--teal-300); transform: translateY(-4px); box-shadow: 0 12px 40px rgba(13,148,136,0.12); }
  .ms-vertical-card::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 4px;
    background: linear-gradient(90deg, var(--teal-500), var(--emerald-600));
    opacity: 0; transition: opacity 0.3s;
  }
  .ms-vertical-card:hover::before { opacity: 1; }
  .ms-vertical-icon {
    width: 56px; height: 56px; border-radius: 16px;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.5rem; color: #fff;
  }
  .ms-vertical-icon.rental { background: linear-gradient(135deg, var(--teal-500), var(--teal-700)); }
  .ms-vertical-icon.courses { background: linear-gradient(135deg, #8b5cf6, #6d28d9); }
  .ms-vertical-icon.marketplace { background: linear-gradient(135deg, var(--amber-500), #d97706); }
  .ms-vertical-title { font-family: var(--font-display); font-size: 1.35rem; font-weight: 700; margin-bottom: 0.75rem; }
  .ms-vertical-desc { color: var(--slate-500); font-size: 0.9rem; line-height: 1.7; margin-bottom: 1.5rem; }
  .ms-vertical-features { list-style: none; display: flex; flex-direction: column; gap: 8px; }
  .ms-vertical-features li {
    display: flex; align-items: center; gap: 8px;
    color: var(--slate-600); font-size: 0.85rem;
  }
  .ms-vertical-features li .ck { color: var(--teal-600); flex-shrink: 0; }

  /* ---- HOW IT WORKS ---- */
  .ms-steps { display: grid; grid-template-columns: repeat(4, 1fr); gap: 2rem; position: relative; }
  .ms-steps::before {
    content: ''; position: absolute; top: 32px; left: 10%; right: 10%;
    height: 2px; background: linear-gradient(90deg, var(--teal-200), var(--teal-400), var(--teal-200));
  }
  .ms-step { text-align: center; position: relative; }
  .ms-step-num {
    width: 64px; height: 64px; border-radius: 50%;
    background: linear-gradient(135deg, var(--teal-500), var(--teal-700));
    color: #fff; font-family: var(--font-display); font-weight: 800; font-size: 1.3rem;
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 1.25rem; position: relative; z-index: 1;
    box-shadow: 0 4px 14px rgba(13,148,136,0.3);
  }
  .ms-step-title { font-weight: 700; font-size: 1rem; margin-bottom: 0.5rem; }
  .ms-step-desc { color: var(--slate-500); font-size: 0.85rem; line-height: 1.6; }

  /* ---- TESTIMONIALS ---- */
  .ms-testimonials-bg {
    background: linear-gradient(160deg, var(--slate-900), var(--teal-900));
    padding: 6rem 2rem;
  }
  .ms-testimonials { max-width: 1200px; margin: 0 auto; }
  .ms-testimonials .ms-section-title { color: #fff; }
  .ms-testimonials .ms-section-tag { color: var(--teal-400); }
  .ms-testimonials .ms-section-desc { color: rgba(255,255,255,0.5); }
  .ms-testimonial-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; }
  .ms-testimonial-card {
    background: rgba(255,255,255,0.05); backdrop-filter: blur(10px);
    border: 1px solid rgba(255,255,255,0.08); border-radius: 20px;
    padding: 2rem;
  }
  .ms-testimonial-stars { display: flex; gap: 2px; margin-bottom: 1rem; }
  .ms-testimonial-text { color: rgba(255,255,255,0.75); font-size: 0.92rem; line-height: 1.7; margin-bottom: 1.5rem; font-style: italic; }
  .ms-testimonial-author { display: flex; align-items: center; gap: 12px; }
  .ms-testimonial-avatar {
    width: 44px; height: 44px; border-radius: 12px;
    background: linear-gradient(135deg, var(--teal-400), var(--teal-600));
    display: flex; align-items: center; justify-content: center;
    color: #fff; font-weight: 700; font-size: 0.85rem;
  }
  .ms-testimonial-name { color: #fff; font-weight: 600; font-size: 0.9rem; }
  .ms-testimonial-role { color: rgba(255,255,255,0.4); font-size: 0.78rem; }

  /* ---- CTA ---- */
  .ms-cta-section {
    text-align: center; padding: 6rem 2rem;
    background: linear-gradient(180deg, var(--slate-50), var(--teal-50));
  }
  .ms-cta-inner { max-width: 600px; margin: 0 auto; }
  .ms-cta-inner h3 {
    font-family: var(--font-display); font-size: 2.4rem; font-weight: 800;
    margin-bottom: 1rem; color: var(--slate-900);
  }
  .ms-cta-inner p { color: var(--slate-500); font-size: 1.05rem; margin-bottom: 2rem; line-height: 1.7; }

  /* ---- FOOTER ---- */
  .ms-footer {
    background: var(--slate-900); padding: 4rem 2rem 2rem; color: rgba(255,255,255,0.5);
  }
  .ms-footer-inner {
    max-width: 1200px; margin: 0 auto;
    display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 3rem;
  }
  .ms-footer-brand p { font-size: 0.85rem; line-height: 1.7; margin-top: 1rem; }
  .ms-footer-col h4 { color: #fff; font-weight: 700; font-size: 0.9rem; margin-bottom: 1rem; }
  .ms-footer-col a {
    display: block; color: rgba(255,255,255,0.5); font-size: 0.85rem;
    margin-bottom: 0.6rem; cursor: pointer; transition: color 0.2s; text-decoration:none;
  }
  .ms-footer-col a:hover { color: var(--teal-400); }
  .ms-footer-bottom {
    max-width: 1200px; margin: 3rem auto 0; padding-top: 2rem;
    border-top: 1px solid rgba(255,255,255,0.08);
    display: flex; justify-content: space-between; font-size: 0.8rem;
  }

  /* ---- DASHBOARD ---- */
  .ms-dash { display: grid; grid-template-columns: 260px 1fr; min-height: calc(100vh - 72px); }
  .ms-sidebar {
    background: #fff; border-right: 1px solid var(--slate-200);
    padding: 2rem 0; display: flex; flex-direction: column;
  }
  .ms-sidebar-item {
    display: flex; align-items: center; gap: 12px;
    padding: 12px 1.5rem; color: var(--slate-500); font-size: 0.88rem;
    font-weight: 500; cursor: pointer; transition: all 0.2s;
    border: none; background: none; font-family: var(--font-body); text-align: left; width: 100%;
  }
  .ms-sidebar-item:hover { background: var(--slate-50); color: var(--slate-700); }
  .ms-sidebar-item.active {
    background: var(--teal-50); color: var(--teal-700);
    border-right: 3px solid var(--teal-600);
  }
  .ms-main { padding: 2rem; background: var(--slate-50); overflow-y: auto; }
  .ms-dash-header { margin-bottom: 2rem; }
  .ms-dash-header h2 { font-family: var(--font-display); font-size: 1.8rem; font-weight: 800; }
  .ms-dash-header p { color: var(--slate-500); margin-top: 4px; }

  .ms-stat-cards { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem; margin-bottom: 2rem; }
  .ms-stat-card {
    background: #fff; border-radius: 16px; padding: 1.5rem;
    border: 1px solid var(--slate-200);
  }
  .ms-stat-card-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.75rem; }
  .ms-stat-card-label { color: var(--slate-500); font-size: 0.82rem; font-weight: 500; }
  .ms-stat-card-icon {
    width: 40px; height: 40px; border-radius: 12px;
    display: flex; align-items: center; justify-content: center;
  }
  .ms-stat-card-icon.teal { background: var(--teal-50); color: var(--teal-600); }
  .ms-stat-card-icon.purple { background: #f3e8ff; color: #8b5cf6; }
  .ms-stat-card-icon.amber { background: #fef3c7; color: #d97706; }
  .ms-stat-card-icon.blue { background: #dbeafe; color: #3b82f6; }
  .ms-stat-card-value { font-family: var(--font-display); font-size: 1.8rem; font-weight: 800; }
  .ms-stat-card-change { font-size: 0.78rem; color: var(--emerald-600); font-weight: 600; margin-top: 4px; }

  /* ---- CARD GRID ---- */
  .ms-card-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 1.25rem; }
  .ms-equip-card {
    background: #fff; border-radius: 18px; overflow: hidden;
    border: 1px solid var(--slate-200); transition: all 0.3s;
    cursor: pointer;
  }
  .ms-equip-card:hover { border-color: var(--teal-300); box-shadow: 0 8px 30px rgba(13,148,136,0.1); transform: translateY(-2px); }
  .ms-equip-card-img {
    height: 200px; background: linear-gradient(135deg, var(--slate-100), var(--teal-50));
    display: flex; align-items: center; justify-content: center;
    position: relative;
  }
  .ms-equip-card-img svg { opacity: 0.3; }
  .ms-equip-card-badge {
    position: absolute; top: 12px; left: 12px;
    padding: 4px 12px; border-radius: 100px; font-size: 0.72rem; font-weight: 700;
  }
  .ms-equip-card-badge.available { background: rgba(5,150,105,0.1); color: var(--emerald-600); }
  .ms-equip-card-badge.rented { background: rgba(239,68,68,0.1); color: var(--red-500); }
  .ms-equip-card-badge.sale { background: rgba(245,158,11,0.1); color: #d97706; }
  .ms-equip-card-fav {
    position: absolute; top: 12px; right: 12px; background: rgba(255,255,255,0.9);
    border: none; width: 36px; height: 36px; border-radius: 50%; cursor: pointer;
    display: flex; align-items: center; justify-content: center; color: var(--slate-400);
    transition: all 0.2s;
  }
  .ms-equip-card-fav:hover { color: var(--red-500); }
  .ms-equip-card-body { padding: 1.25rem; }
  .ms-equip-card-title { font-weight: 700; font-size: 1rem; margin-bottom: 4px; }
  .ms-equip-card-subtitle { color: var(--slate-400); font-size: 0.82rem; display: flex; align-items: center; gap: 4px; }
  .ms-equip-card-footer {
    display: flex; justify-content: space-between; align-items: center;
    margin-top: 1rem; padding-top: 1rem; border-top: 1px solid var(--slate-100);
  }
  .ms-equip-card-price { font-family: var(--font-display); font-weight: 800; font-size: 1.15rem; color: var(--teal-700); }
  .ms-equip-card-price span { font-size: 0.78rem; font-weight: 500; color: var(--slate-400); }
  .ms-equip-card-rating { display: flex; align-items: center; gap: 4px; font-size: 0.82rem; color: var(--slate-500); }

  /* ---- COURSE CARD ---- */
  .ms-course-card {
    background: #fff; border-radius: 18px; overflow: hidden;
    border: 1px solid var(--slate-200); transition: all 0.3s; cursor: pointer;
  }
  .ms-course-card:hover { border-color: #a78bfa; box-shadow: 0 8px 30px rgba(139,92,246,0.1); transform: translateY(-2px); }
  .ms-course-card-img {
    height: 180px; position: relative;
    display: flex; align-items: center; justify-content: center;
  }
  .ms-course-card-img.c1 { background: linear-gradient(135deg, #0d9488, #065f46); }
  .ms-course-card-img.c2 { background: linear-gradient(135deg, #7c3aed, #4c1d95); }
  .ms-course-card-img.c3 { background: linear-gradient(135deg, #d97706, #92400e); }
  .ms-course-card-img.c4 { background: linear-gradient(135deg, #2563eb, #1e3a8a); }
  .ms-course-card-play {
    width: 56px; height: 56px; border-radius: 50%;
    background: rgba(255,255,255,0.2); display: flex;
    align-items: center; justify-content: center; color: #fff;
  }
  .ms-course-card-level {
    position: absolute; top: 12px; left: 12px;
    background: rgba(0,0,0,0.3); backdrop-filter: blur(10px);
    color: #fff; padding: 4px 12px; border-radius: 100px;
    font-size: 0.72rem; font-weight: 600;
  }
  .ms-course-card-body { padding: 1.25rem; }
  .ms-course-card-title { font-weight: 700; font-size: 1rem; margin-bottom: 6px; }
  .ms-course-card-instructor { color: var(--slate-400); font-size: 0.82rem; margin-bottom: 12px; }
  .ms-course-card-meta { display: flex; gap: 1rem; color: var(--slate-400); font-size: 0.8rem; }
  .ms-course-card-meta span { display: flex; align-items: center; gap: 4px; }
  .ms-course-card-footer {
    display: flex; justify-content: space-between; align-items: center;
    margin-top: 1rem; padding-top: 1rem; border-top: 1px solid var(--slate-100);
  }
  .ms-course-card-price { font-family: var(--font-display); font-weight: 800; font-size: 1.15rem; color: #7c3aed; }
  .ms-course-card-students { font-size: 0.8rem; color: var(--slate-400); }

  /* ---- FILTERS ---- */
  .ms-filters {
    display: flex; gap: 0.75rem; margin-bottom: 2rem; flex-wrap: wrap; align-items: center;
  }
  .ms-filter-search {
    display: flex; align-items: center; gap: 8px;
    background: #fff; border: 1px solid var(--slate-200); border-radius: 12px;
    padding: 10px 16px; flex: 1; min-width: 280px;
  }
  .ms-filter-search input {
    border: none; outline: none; font-family: var(--font-body);
    font-size: 0.9rem; width: 100%; background: transparent;
  }
  .ms-filter-search svg { color: var(--slate-400); flex-shrink: 0; }
  .ms-filter-tag {
    padding: 8px 16px; border-radius: 100px; font-size: 0.82rem;
    font-weight: 600; cursor: pointer; transition: all 0.2s;
    border: 1px solid var(--slate-200); background: #fff; color: var(--slate-600);
    font-family: var(--font-body);
  }
  .ms-filter-tag.active { background: var(--teal-600); color: #fff; border-color: var(--teal-600); }
  .ms-filter-tag:hover:not(.active) { border-color: var(--teal-300); }

  /* ---- DETAIL PAGE ---- */
  .ms-detail { max-width: 1000px; margin: 0 auto; }
  .ms-detail-back {
    display: flex; align-items: center; gap: 8px;
    color: var(--slate-500); font-size: 0.88rem; cursor: pointer;
    margin-bottom: 1.5rem; background: none; border: none; font-family: var(--font-body);
  }
  .ms-detail-back:hover { color: var(--teal-600); }
  .ms-detail-grid { display: grid; grid-template-columns: 1.2fr 1fr; gap: 2.5rem; }
  .ms-detail-img {
    height: 400px; border-radius: 20px;
    display: flex; align-items: center; justify-content: center;
  }
  .ms-detail-img.equip { background: linear-gradient(135deg, var(--slate-100), var(--teal-50)); }
  .ms-detail-img.course { background: linear-gradient(135deg, #7c3aed, #4c1d95); }
  .ms-detail-img svg { opacity: 0.25; }
  .ms-detail-info { display: flex; flex-direction: column; }
  .ms-detail-badge {
    display: inline-flex; width: fit-content;
    padding: 4px 14px; border-radius: 100px; font-size: 0.78rem; font-weight: 700;
    margin-bottom: 1rem;
  }
  .ms-detail-badge.available { background: rgba(5,150,105,0.1); color: var(--emerald-600); }
  .ms-detail-badge.course-badge { background: rgba(139,92,246,0.1); color: #7c3aed; }
  .ms-detail-title {
    font-family: var(--font-display); font-size: 2rem; font-weight: 800;
    margin-bottom: 0.5rem;
  }
  .ms-detail-subtitle { color: var(--slate-500); font-size: 0.95rem; margin-bottom: 1.5rem; }
  .ms-detail-specs {
    display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 1.5rem;
  }
  .ms-detail-spec {
    background: var(--slate-50); border-radius: 12px; padding: 14px;
  }
  .ms-detail-spec-label { color: var(--slate-400); font-size: 0.75rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; }
  .ms-detail-spec-value { font-weight: 700; font-size: 0.95rem; margin-top: 4px; }
  .ms-detail-price-box {
    background: linear-gradient(135deg, var(--teal-50), #fff);
    border: 2px solid var(--teal-200); border-radius: 16px;
    padding: 1.5rem; margin-top: auto;
  }
  .ms-detail-price-label { color: var(--slate-500); font-size: 0.82rem; }
  .ms-detail-price {
    font-family: var(--font-display); font-size: 2.2rem; font-weight: 800;
    color: var(--teal-700); margin: 4px 0 1rem;
  }
  .ms-detail-price span { font-size: 1rem; font-weight: 500; color: var(--slate-400); }

  /* ---- PROFILE ---- */
  .ms-profile-header {
    background: linear-gradient(135deg, var(--teal-600), var(--emerald-700));
    border-radius: 24px; padding: 3rem; color: #fff;
    display: flex; gap: 2rem; align-items: center; margin-bottom: 2rem;
  }
  .ms-profile-avatar {
    width: 100px; height: 100px; border-radius: 24px;
    background: rgba(255,255,255,0.2); display: flex;
    align-items: center; justify-content: center;
    font-family: var(--font-display); font-size: 2.5rem; font-weight: 800;
  }
  .ms-profile-name { font-family: var(--font-display); font-size: 1.8rem; font-weight: 800; }
  .ms-profile-specialty { opacity: 0.7; margin-top: 4px; }
  .ms-profile-badges { display: flex; gap: 8px; margin-top: 1rem; }
  .ms-profile-badge-item {
    background: rgba(255,255,255,0.15); padding: 6px 14px;
    border-radius: 100px; font-size: 0.78rem; font-weight: 600;
    display: flex; align-items: center; gap: 6px;
  }
  .ms-profile-stats {
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem; margin-bottom: 2rem;
  }
  .ms-profile-stat-card {
    background: #fff; border-radius: 16px; padding: 1.5rem;
    border: 1px solid var(--slate-200); text-align: center;
  }
  .ms-profile-stat-value { font-family: var(--font-display); font-size: 1.6rem; font-weight: 800; color: var(--teal-700); }
  .ms-profile-stat-label { color: var(--slate-500); font-size: 0.82rem; margin-top: 4px; }

  .ms-tabs { display: flex; gap: 0; margin-bottom: 2rem; border-bottom: 2px solid var(--slate-200); }
  .ms-tab {
    padding: 12px 24px; font-weight: 600; font-size: 0.9rem;
    color: var(--slate-400); cursor: pointer; transition: all 0.2s;
    border-bottom: 2px solid transparent; margin-bottom: -2px;
    background: none; border-top: none; border-left: none; border-right: none;
    font-family: var(--font-body);
  }
  .ms-tab.active { color: var(--teal-700); border-bottom-color: var(--teal-600); }
  .ms-tab:hover:not(.active) { color: var(--slate-600); }

  /* ---- ANIMATIONS ---- */
  @keyframes fadeUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
  @keyframes slideIn { from { opacity: 0; transform: translateX(-20px); } to { opacity: 1; transform: translateX(0); } }
  .fade-in { animation: fadeUp 0.5s ease-out; }

  /* ---- RESPONSIVE ---- */
  @media (max-width: 1024px) {
    .ms-hero-content { grid-template-columns: 1fr; text-align: center; }
    .ms-hero h2 { font-size: 2.8rem; }
    .ms-hero-sub { margin: 0 auto 2rem; }
    .ms-hero-btns { justify-content: center; }
    .ms-hero-stats { justify-content: center; }
    .ms-hero-visual { display: none; }
    .ms-verticals { grid-template-columns: 1fr; }
    .ms-steps { grid-template-columns: repeat(2, 1fr); }
    .ms-steps::before { display: none; }
    .ms-testimonial-grid { grid-template-columns: 1fr; }
    .ms-footer-inner { grid-template-columns: 1fr 1fr; }
    .ms-dash { grid-template-columns: 1fr; }
    .ms-sidebar { display: none; }
    .ms-stat-cards { grid-template-columns: repeat(2, 1fr); }
    .ms-detail-grid { grid-template-columns: 1fr; }
    .ms-profile-header { flex-direction: column; text-align: center; }
    .ms-profile-badges { justify-content: center; }
    .ms-profile-stats { grid-template-columns: repeat(2, 1fr); }
    .ms-nav-links { display: none; }
    .ms-mobile-toggle { display: block; }
  }
  @media (max-width: 640px) {
    .ms-hero { min-height: 80vh; padding: 4rem 1.25rem; }
    .ms-hero h2 { font-size: 2.2rem; }
    .ms-section { padding: 4rem 1.25rem; }
    .ms-section-title { font-size: 2rem; }
    .ms-stat-cards { grid-template-columns: 1fr; }
    .ms-card-grid { grid-template-columns: 1fr; }
    .ms-hero-stats { flex-direction: column; gap: 1.5rem; align-items: center; }
    .ms-footer-inner { grid-template-columns: 1fr; }
  }
`;

// --- DATA ---
const equipments = [
  { id: 1, name: "Candela GentleMax Pro Plus", brand: "Candela", type: "Alexandrite / Nd:YAG", location: "São Paulo, SP", price: 450, period: "hora", rating: 4.9, reviews: 47, available: true, mode: "local", desc: "Laser de alta potência para depilação e lesões vasculares. Ponteira de 24mm." },
  { id: 2, name: "Cynosure PicoSure Pro", brand: "Cynosure", type: "Picossegundo", location: "Rio de Janeiro, RJ", price: 600, period: "hora", rating: 4.8, reviews: 32, available: true, mode: "both", desc: "Referência em remoção de tatuagem e rejuvenescimento. Tecnologia picossegundo." },
  { id: 3, name: "Alma Soprano ICE Platinum", brand: "Alma Lasers", type: "Diodo", location: "Belo Horizonte, MG", price: 350, period: "hora", rating: 4.7, reviews: 58, available: false, mode: "transport", desc: "Sistema SHR para depilação indolor. Três comprimentos de onda combinados." },
  { id: 4, name: "Lutronic Hollywood Spectra", brand: "Lutronic", type: "Nd:YAG Q-Switched", location: "Curitiba, PR", price: 500, period: "hora", rating: 4.9, reviews: 21, available: true, mode: "local", desc: "Toning facial, melasma e remoção de pigmentos. Modo Hollywood Peel." },
  { id: 5, name: "Sciton Joule X", brand: "Sciton", type: "Plataforma Multi-laser", location: "Porto Alegre, RS", price: 800, period: "hora", rating: 5.0, reviews: 15, available: true, mode: "local", desc: "Plataforma completa com BBL, MOXI, HALO. Topo de linha em rejuvenescimento." },
  { id: 6, name: "Fotona SP Dynamis", brand: "Fotona", type: "Er:YAG / Nd:YAG", location: "Brasília, DF", price: 550, period: "hora", rating: 4.8, reviews: 38, available: true, mode: "both", desc: "Dois lasers em um. Procedimentos íntimos, faciais e corporais." },
];

const courses = [
  { id: 1, title: "Laser Alexandrite: Do Básico ao Avançado", instructor: "Dra. Marina Costa", level: "Intermediário", hours: 12, students: 234, price: 1290, color: "c1", cert: true },
  { id: 2, title: "Picossegundo na Prática Clínica", instructor: "Dr. Ricardo Almeida", level: "Avançado", hours: 8, students: 156, price: 1890, color: "c2", cert: true },
  { id: 3, title: "Depilação a Laser: Protocolos e Segurança", instructor: "Dra. Fernanda Lima", level: "Básico", hours: 6, students: 412, price: 690, color: "c3", cert: true },
  { id: 4, title: "Lasers Vasculares e Pigmentares", instructor: "Dr. Paulo Henrique", level: "Avançado", hours: 10, students: 89, price: 1590, color: "c4", cert: true },
  { id: 5, title: "MOXI e HALO: Rejuvenescimento Fracionado", instructor: "Dra. Beatriz Santos", level: "Intermediário", hours: 8, students: 178, price: 1490, color: "c1", cert: true },
  { id: 6, title: "Certificação MedShare em Lasers", instructor: "Equipe MedShare", level: "Completo", hours: 40, students: 67, price: 3990, color: "c2", cert: true },
];

const marketplaceItems = [
  { id: 1, name: "Candela GentleMax Pro (2021)", condition: "Excelente", price: 185000, location: "São Paulo, SP", shots: "12.000 disparos", anvisa: true },
  { id: 2, name: "Alma Soprano ICE (2020)", condition: "Bom", price: 120000, location: "Campinas, SP", shots: "45.000 disparos", anvisa: true },
  { id: 3, name: "Lutronic Spectra XT (2022)", condition: "Como novo", price: 210000, location: "Rio de Janeiro, RJ", shots: "3.500 disparos", anvisa: true },
  { id: 4, name: "Zimmer Cryo 6 (2019)", condition: "Bom", price: 28000, location: "Belo Horizonte, MG", shots: "N/A", anvisa: true },
  { id: 5, name: "Fotona StarWalker MaQX (2023)", condition: "Excelente", price: 350000, location: "Curitiba, PR", shots: "8.000 disparos", anvisa: true },
  { id: 6, name: "Cynosure Elite iQ (2022)", condition: "Excelente", price: 275000, location: "Florianópolis, SC", shots: "6.200 disparos", anvisa: true },
];

const testimonials = [
  { name: "Dra. Camila Rocha", role: "Dermatologista — SP", initials: "CR", text: "Recuperei o investimento do meu laser em 3 meses alugando nos horários ociosos. A plataforma trouxe médicos qualificados e certificados." },
  { name: "Dr. André Martins", role: "Cirurgião Plástico — RJ", initials: "AM", text: "Consegui testar o Picossegundo antes de comprar. Aluguei por 3 meses, fiz os cursos, e depois comprei pelo marketplace com confiança total." },
  { name: "Dra. Juliana Ferreira", role: "Dermatologista — MG", initials: "JF", text: "Os cursos de certificação são excelentes. Meus pacientes notam a diferença quando uso equipamentos de ponta que consigo alugar pela MedShare." },
];

// --- COMPONENTS ---

const StarRating = ({ rating }) => (
  <div style={{ display: "flex", gap: 2 }}>
    {[1,2,3,4,5].map(i => <Icons.Star key={i} filled={i <= Math.round(rating)} />)}
  </div>
);

// ===================== NAVBAR =====================
const Navbar = ({ page, setPage, isLoggedIn }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <nav className="ms-nav">
      <div className="ms-nav-logo" onClick={() => setPage("landing")}>
        <Icons.Logo />
        <h1>MedShare</h1>
      </div>
      <div className="ms-nav-links">
        {["landing","rental","courses","marketplace"].map(p => (
          <button key={p} className={`ms-nav-link ${page === p ? "active" : ""}`} onClick={() => setPage(p)}>
            {{ landing: "Início", rental: "Locação", courses: "Cursos", marketplace: "Marketplace" }[p]}
          </button>
        ))}
      </div>
      <div className="ms-nav-actions">
        {isLoggedIn ? (
          <>
            <button className="ms-nav-bell" onClick={() => {}}>
              <Icons.Bell />
              <div className="ms-nav-bell-dot" />
            </button>
            <div className="ms-nav-avatar" onClick={() => setPage("profile")}>DR</div>
          </>
        ) : (
          <>
            <button className="ms-btn ms-btn-ghost ms-btn-sm" onClick={() => setPage("dashboard")}>Entrar</button>
            <button className="ms-btn ms-btn-primary ms-btn-sm" onClick={() => setPage("dashboard")}>Cadastre-se</button>
          </>
        )}
        <button className="ms-mobile-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <Icons.X /> : <Icons.Menu />}
        </button>
      </div>
    </nav>
  );
};

// ===================== LANDING PAGE =====================
const LandingPage = ({ setPage }) => (
  <div>
    {/* HERO */}
    <section className="ms-hero">
      <div className="ms-hero-grid" />
      <div className="ms-hero-content">
        <div className="ms-hero-text">
          <div className="ms-hero-badge">
            <div className="ms-hero-badge-dot" />
            Plataforma #1 em equipamentos médicos
          </div>
          <h2>
            Seu laser parado<br />
            é <span>dinheiro perdido</span>
          </h2>
          <p className="ms-hero-sub">
            Alugue, aprenda e negocie equipamentos médicos na maior comunidade de profissionais de saúde do Brasil. Monetize seu tempo ocioso.
          </p>
          <div className="ms-hero-btns">
            <button className="ms-btn ms-btn-primary ms-btn-lg" onClick={() => setPage("dashboard")}>
              Começar agora — é grátis
            </button>
            <button className="ms-btn ms-btn-secondary ms-btn-lg" style={{ background: "rgba(255,255,255,0.08)", color: "#fff", border: "1px solid rgba(255,255,255,0.2)" }} onClick={() => setPage("rental")}>
              Explorar equipamentos
            </button>
          </div>
          <div className="ms-hero-stats">
            <div>
              <div className="ms-hero-stat-num">2.400+</div>
              <div className="ms-hero-stat-label">Médicos cadastrados</div>
            </div>
            <div>
              <div className="ms-hero-stat-num">850+</div>
              <div className="ms-hero-stat-label">Equipamentos disponíveis</div>
            </div>
            <div>
              <div className="ms-hero-stat-num">R$4.2M</div>
              <div className="ms-hero-stat-label">Transacionados/mês</div>
            </div>
          </div>
        </div>
        <div className="ms-hero-visual">
          <div className="ms-hero-card">
            <div className="ms-hero-card-header">
              <div>
                <div className="ms-hero-card-title">Disponíveis agora</div>
                <div className="ms-hero-card-sub">São Paulo, SP</div>
              </div>
              <div className="ms-hero-card-badge-live">
                <div className="ms-hero-card-badge-dot" /> AO VIVO
              </div>
            </div>
            <div className="ms-hero-card-items">
              {[
                { name: "GentleMax Pro Plus", detail: "Candela · Alexandrite", price: "R$450/h" },
                { name: "PicoSure Pro", detail: "Cynosure · Picossegundo", price: "R$600/h" },
                { name: "Hollywood Spectra", detail: "Lutronic · Nd:YAG", price: "R$500/h" },
              ].map((item, i) => (
                <div key={i} className="ms-hero-card-item">
                  <div>
                    <div className="ms-hero-card-item-name">{item.name}</div>
                    <div className="ms-hero-card-item-detail">{item.detail}</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div className="ms-hero-card-item-price">{item.price}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* VERTICALS */}
    <section className="ms-section">
      <div className="ms-section-header">
        <div className="ms-section-tag"><Icons.Grid /> ECOSSISTEMA COMPLETO</div>
        <h3 className="ms-section-title">Três soluções, uma plataforma</h3>
        <p className="ms-section-desc">Tudo que você precisa para maximizar seus equipamentos médicos em um único lugar.</p>
      </div>
      <div className="ms-verticals">
        <div className="ms-vertical-card" onClick={() => setPage("rental")}>
          <div className="ms-vertical-icon rental"><Icons.Laser /></div>
          <h4 className="ms-vertical-title">Locação de Equipamentos</h4>
          <p className="ms-vertical-desc">Alugue lasers e equipamentos por hora ou período. Monetize seu investimento nos horários ociosos.</p>
          <ul className="ms-vertical-features">
            <li><span className="ck"><Icons.Check /></span> Agendamento online em tempo real</li>
            <li><span className="ck"><Icons.Check /></span> Seguro incluso em todas as locações</li>
            <li><span className="ck"><Icons.Check /></span> Apenas profissionais certificados</li>
            <li><span className="ck"><Icons.Check /></span> Uso no local ou transporte</li>
          </ul>
        </div>
        <div className="ms-vertical-card" onClick={() => setPage("courses")}>
          <div className="ms-vertical-icon courses"><Icons.Book /></div>
          <h4 className="ms-vertical-title">Cursos e Certificações</h4>
          <p className="ms-vertical-desc">Aprenda a operar equipamentos com segurança e obtenha certificações reconhecidas pelo mercado.</p>
          <ul className="ms-vertical-features">
            <li><span className="ck"><Icons.Check /></span> Aulas com especialistas renomados</li>
            <li><span className="ck"><Icons.Check /></span> Certificado digital verificável</li>
            <li><span className="ck"><Icons.Check /></span> Prática em equipamentos reais</li>
            <li><span className="ck"><Icons.Check /></span> Habilitação para locação</li>
          </ul>
        </div>
        <div className="ms-vertical-card" onClick={() => setPage("marketplace")}>
          <div className="ms-vertical-icon marketplace"><Icons.Cart /></div>
          <h4 className="ms-vertical-title">Marketplace</h4>
          <p className="ms-vertical-desc">Compre e venda equipamentos seminovos com documentação verificada e histórico completo.</p>
          <ul className="ms-vertical-features">
            <li><span className="ck"><Icons.Check /></span> Registro ANVISA verificado</li>
            <li><span className="ck"><Icons.Check /></span> Histórico de manutenção</li>
            <li><span className="ck"><Icons.Check /></span> Laudo técnico independente</li>
            <li><span className="ck"><Icons.Check /></span> Pagamento seguro via plataforma</li>
          </ul>
        </div>
      </div>
    </section>

    {/* HOW IT WORKS */}
    <section style={{ background: "#fff", padding: "6rem 2rem" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div className="ms-section-header">
          <div className="ms-section-tag"><Icons.TrendingUp /> SIMPLES E RÁPIDO</div>
          <h3 className="ms-section-title">Como funciona</h3>
          <p className="ms-section-desc">Em poucos passos você já está monetizando ou utilizando equipamentos de ponta.</p>
        </div>
        <div className="ms-steps">
          {[
            { num: "1", title: "Cadastre-se", desc: "Crie sua conta com validação de CRM. Leva menos de 2 minutos." },
            { num: "2", title: "Explore ou Cadastre", desc: "Busque equipamentos para alugar ou cadastre os seus para locação." },
            { num: "3", title: "Certifique-se", desc: "Complete cursos e obtenha certificações para alugar equipamentos." },
            { num: "4", title: "Conecte-se", desc: "Agende, alugue e comece a usar ou ganhar com seus equipamentos." },
          ].map((step, i) => (
            <div key={i} className="ms-step">
              <div className="ms-step-num">{step.num}</div>
              <h4 className="ms-step-title">{step.title}</h4>
              <p className="ms-step-desc">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* TESTIMONIALS */}
    <section className="ms-testimonials-bg">
      <div className="ms-testimonials">
        <div className="ms-section-header">
          <div className="ms-section-tag"><Icons.Heart /> DEPOIMENTOS</div>
          <h3 className="ms-section-title">Quem usa, recomenda</h3>
          <p className="ms-section-desc">Histórias reais de médicos que transformaram suas práticas com a MedShare.</p>
        </div>
        <div className="ms-testimonial-grid">
          {testimonials.map((t, i) => (
            <div key={i} className="ms-testimonial-card">
              <div className="ms-testimonial-stars"><StarRating rating={5} /></div>
              <p className="ms-testimonial-text">"{t.text}"</p>
              <div className="ms-testimonial-author">
                <div className="ms-testimonial-avatar">{t.initials}</div>
                <div>
                  <div className="ms-testimonial-name">{t.name}</div>
                  <div className="ms-testimonial-role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="ms-cta-section">
      <div className="ms-cta-inner">
        <h3>Pronto para começar?</h3>
        <p>Junte-se a mais de 2.400 médicos que já estão maximizando o retorno dos seus equipamentos.</p>
        <button className="ms-btn ms-btn-primary ms-btn-lg" onClick={() => setPage("dashboard")}>
          Criar conta gratuita
        </button>
      </div>
    </section>

    {/* FOOTER */}
    <footer className="ms-footer">
      <div className="ms-footer-inner">
        <div className="ms-footer-brand">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Icons.Logo />
            <span style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "1.3rem", color: "#fff" }}>MedShare</span>
          </div>
          <p>A maior plataforma de compartilhamento de equipamentos médicos do Brasil. Conectando profissionais de saúde desde 2025.</p>
        </div>
        <div className="ms-footer-col">
          <h4>Plataforma</h4>
          <a onClick={() => setPage("rental")}>Locação</a>
          <a onClick={() => setPage("courses")}>Cursos</a>
          <a onClick={() => setPage("marketplace")}>Marketplace</a>
          <a>Preços</a>
        </div>
        <div className="ms-footer-col">
          <h4>Suporte</h4>
          <a>Central de Ajuda</a>
          <a>Contato</a>
          <a>Termos de Uso</a>
          <a>Privacidade</a>
        </div>
        <div className="ms-footer-col">
          <h4>Comunidade</h4>
          <a>Blog</a>
          <a>Eventos</a>
          <a>Parceiros</a>
          <a>Indicação</a>
        </div>
      </div>
      <div className="ms-footer-bottom">
        <span>© 2025 MedShare. Todos os direitos reservados.</span>
        <span>Feito com dedicação para a comunidade médica brasileira</span>
      </div>
    </footer>
  </div>
);

// ===================== RENTAL PAGE =====================
const RentalPage = ({ setPage, setSelectedEquip }) => {
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const filtered = equipments.filter(e => {
    if (filter === "available" && !e.available) return false;
    if (filter === "local" && e.mode === "transport") return false;
    if (filter === "transport" && e.mode === "local") return false;
    if (search && !e.name.toLowerCase().includes(search.toLowerCase()) && !e.brand.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
  return (
    <div className="ms-section fade-in">
      <div className="ms-dash-header">
        <h2>Locação de Equipamentos</h2>
        <p>Encontre lasers e equipamentos disponíveis para aluguel por hora ou período.</p>
      </div>
      <div className="ms-filters">
        <div className="ms-filter-search">
          <Icons.Search />
          <input placeholder="Buscar por equipamento, marca ou tipo..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        {[
          { key: "all", label: "Todos" },
          { key: "available", label: "Disponíveis" },
          { key: "local", label: "Uso no local" },
          { key: "transport", label: "Com transporte" },
        ].map(f => (
          <button key={f.key} className={`ms-filter-tag ${filter === f.key ? "active" : ""}`} onClick={() => setFilter(f.key)}>
            {f.label}
          </button>
        ))}
      </div>
      <div className="ms-card-grid">
        {filtered.map(eq => (
          <div key={eq.id} className="ms-equip-card" onClick={() => { setSelectedEquip(eq); setPage("equip-detail"); }}>
            <div className="ms-equip-card-img">
              <Icons.Laser />
              <span className={`ms-equip-card-badge ${eq.available ? "available" : "rented"}`}>
                {eq.available ? "Disponível" : "Locado"}
              </span>
              <button className="ms-equip-card-fav" onClick={e => e.stopPropagation()}><Icons.Heart /></button>
            </div>
            <div className="ms-equip-card-body">
              <div className="ms-equip-card-title">{eq.name}</div>
              <div className="ms-equip-card-subtitle"><Icons.MapPin /> {eq.location}</div>
              <div className="ms-equip-card-footer">
                <div className="ms-equip-card-price">R${eq.price} <span>/{eq.period}</span></div>
                <div className="ms-equip-card-rating">
                  <Icons.Star filled /> {eq.rating} ({eq.reviews})
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ===================== EQUIPMENT DETAIL =====================
const EquipDetailPage = ({ equip, setPage }) => {
  if (!equip) return null;
  return (
    <div className="ms-section fade-in">
      <div className="ms-detail">
        <button className="ms-detail-back" onClick={() => setPage("rental")}>
          <Icons.ArrowLeft /> Voltar para equipamentos
        </button>
        <div className="ms-detail-grid">
          <div className="ms-detail-img equip">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" style={{ opacity: 0.15 }}>
              <circle cx="12" cy="12" r="3" /><path d="M12 2v4m0 12v4M2 12h4m12 0h4" />
            </svg>
          </div>
          <div className="ms-detail-info">
            <div className="ms-detail-badge available">Disponível para locação</div>
            <h2 className="ms-detail-title">{equip.name}</h2>
            <p className="ms-detail-subtitle">{equip.desc}</p>
            <div className="ms-detail-specs">
              <div className="ms-detail-spec">
                <div className="ms-detail-spec-label">Marca</div>
                <div className="ms-detail-spec-value">{equip.brand}</div>
              </div>
              <div className="ms-detail-spec">
                <div className="ms-detail-spec-label">Tipo</div>
                <div className="ms-detail-spec-value">{equip.type}</div>
              </div>
              <div className="ms-detail-spec">
                <div className="ms-detail-spec-label">Localização</div>
                <div className="ms-detail-spec-value">{equip.location}</div>
              </div>
              <div className="ms-detail-spec">
                <div className="ms-detail-spec-label">Modalidade</div>
                <div className="ms-detail-spec-value">
                  {{ local: "Uso no local", transport: "Com transporte", both: "Local ou transporte" }[equip.mode]}
                </div>
              </div>
            </div>
            <div className="ms-detail-price-box">
              <div className="ms-detail-price-label">Valor da locação</div>
              <div className="ms-detail-price">R${equip.price} <span>/hora</span></div>
              <button className="ms-btn ms-btn-primary" style={{ width: "100%" }}>
                <Icons.Calendar /> Agendar locação
              </button>
              <div style={{ display: "flex", gap: "0.75rem", marginTop: "0.75rem" }}>
                <button className="ms-btn ms-btn-secondary ms-btn-sm" style={{ flex: 1 }}>Enviar mensagem</button>
                <button className="ms-btn ms-btn-ghost ms-btn-sm" style={{ flex: 1 }}>
                  <Icons.Heart /> Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ===================== COURSES PAGE =====================
const CoursesPage = ({ setPage, setSelectedCourse }) => {
  const [filter, setFilter] = useState("all");
  const filtered = courses.filter(c => {
    if (filter === "all") return true;
    return c.level.toLowerCase().includes(filter);
  });
  return (
    <div className="ms-section fade-in">
      <div className="ms-dash-header">
        <h2>Cursos e Certificações</h2>
        <p>Domine equipamentos com segurança. Certificações que habilitam locação.</p>
      </div>
      <div className="ms-filters">
        <div className="ms-filter-search">
          <Icons.Search />
          <input placeholder="Buscar cursos..." />
        </div>
        {["all","básico","intermediário","avançado","completo"].map(f => (
          <button key={f} className={`ms-filter-tag ${filter === f ? "active" : ""}`} onClick={() => setFilter(f)}>
            {f === "all" ? "Todos" : f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>
      <div className="ms-card-grid">
        {filtered.map(c => (
          <div key={c.id} className="ms-course-card" onClick={() => { setSelectedCourse(c); setPage("course-detail"); }}>
            <div className={`ms-course-card-img ${c.color}`}>
              <div className="ms-course-card-play"><Icons.Play /></div>
              <div className="ms-course-card-level">{c.level}</div>
            </div>
            <div className="ms-course-card-body">
              <div className="ms-course-card-title">{c.title}</div>
              <div className="ms-course-card-instructor">{c.instructor}</div>
              <div className="ms-course-card-meta">
                <span><Icons.Clock /> {c.hours}h</span>
                <span><Icons.User /> {c.students} alunos</span>
                {c.cert && <span><Icons.Award /> Certificado</span>}
              </div>
              <div className="ms-course-card-footer">
                <div className="ms-course-card-price">R${c.price.toLocaleString()}</div>
                <div className="ms-course-card-students">{c.students} inscritos</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ===================== COURSE DETAIL =====================
const CourseDetailPage = ({ course, setPage }) => {
  if (!course) return null;
  return (
    <div className="ms-section fade-in">
      <div className="ms-detail">
        <button className="ms-detail-back" onClick={() => setPage("courses")}>
          <Icons.ArrowLeft /> Voltar para cursos
        </button>
        <div className="ms-detail-grid">
          <div className="ms-detail-img course">
            <div style={{ textAlign: "center", color: "#fff" }}>
              <div style={{ width: 72, height: 72, borderRadius: "50%", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 1rem" }}>
                <Icons.Play />
              </div>
              <div style={{ fontWeight: 700, fontSize: "1.1rem" }}>{course.hours} horas de conteúdo</div>
              <div style={{ opacity: 0.6, fontSize: "0.85rem", marginTop: 4 }}>Acesso vitalício</div>
            </div>
          </div>
          <div className="ms-detail-info">
            <div className="ms-detail-badge course-badge">{course.level}</div>
            <h2 className="ms-detail-title">{course.title}</h2>
            <p className="ms-detail-subtitle">por {course.instructor}</p>
            <div className="ms-detail-specs">
              <div className="ms-detail-spec">
                <div className="ms-detail-spec-label">Duração</div>
                <div className="ms-detail-spec-value">{course.hours} horas</div>
              </div>
              <div className="ms-detail-spec">
                <div className="ms-detail-spec-label">Alunos</div>
                <div className="ms-detail-spec-value">{course.students}</div>
              </div>
              <div className="ms-detail-spec">
                <div className="ms-detail-spec-label">Certificado</div>
                <div className="ms-detail-spec-value">Sim — Digital verificável</div>
              </div>
              <div className="ms-detail-spec">
                <div className="ms-detail-spec-label">Habilita locação</div>
                <div className="ms-detail-spec-value">Sim</div>
              </div>
            </div>
            <div className="ms-detail-price-box" style={{ borderColor: "#c4b5fd", background: "linear-gradient(135deg, #f5f3ff, #fff)" }}>
              <div className="ms-detail-price-label">Investimento</div>
              <div className="ms-detail-price" style={{ color: "#7c3aed" }}>R${course.price.toLocaleString()}</div>
              <button className="ms-btn ms-btn-primary" style={{ width: "100%", background: "linear-gradient(135deg, #7c3aed, #6d28d9)", boxShadow: "0 4px 14px rgba(124,58,237,0.35)" }}>
                <Icons.Award /> Inscrever-se agora
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ===================== MARKETPLACE PAGE =====================
const MarketplacePage = ({ setPage }) => {
  const [filter, setFilter] = useState("all");
  return (
    <div className="ms-section fade-in">
      <div className="ms-dash-header">
        <h2>Marketplace</h2>
        <p>Compre e venda equipamentos médicos com documentação verificada.</p>
      </div>
      <div className="ms-filters">
        <div className="ms-filter-search">
          <Icons.Search />
          <input placeholder="Buscar equipamentos à venda..." />
        </div>
        {[
          { key: "all", label: "Todos" },
          { key: "excellent", label: "Excelente" },
          { key: "new", label: "Como novo" },
        ].map(f => (
          <button key={f.key} className={`ms-filter-tag ${filter === f.key ? "active" : ""}`} onClick={() => setFilter(f.key)}>
            {f.label}
          </button>
        ))}
      </div>
      <div className="ms-card-grid">
        {marketplaceItems.map(item => (
          <div key={item.id} className="ms-equip-card">
            <div className="ms-equip-card-img">
              <Icons.Cart />
              <span className="ms-equip-card-badge sale">À Venda</span>
              <button className="ms-equip-card-fav" onClick={e => e.stopPropagation()}><Icons.Heart /></button>
            </div>
            <div className="ms-equip-card-body">
              <div className="ms-equip-card-title">{item.name}</div>
              <div className="ms-equip-card-subtitle">
                <Icons.MapPin /> {item.location} · {item.condition}
              </div>
              <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.75rem", flexWrap: "wrap" }}>
                <span style={{ background: "var(--teal-50)", color: "var(--teal-700)", padding: "3px 10px", borderRadius: 100, fontSize: "0.72rem", fontWeight: 600 }}>
                  {item.shots}
                </span>
                {item.anvisa && (
                  <span style={{ background: "#dbeafe", color: "#2563eb", padding: "3px 10px", borderRadius: 100, fontSize: "0.72rem", fontWeight: 600 }}>
                    ANVISA ✓
                  </span>
                )}
              </div>
              <div className="ms-equip-card-footer">
                <div className="ms-equip-card-price" style={{ color: "#d97706" }}>
                  R${(item.price / 1000).toFixed(0)}mil
                </div>
                <button className="ms-btn ms-btn-primary ms-btn-sm">Ver detalhes</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ===================== DASHBOARD =====================
const DashboardPage = ({ setPage }) => {
  const [sidebarItem, setSidebarItem] = useState("overview");
  return (
    <div className="ms-dash fade-in">
      <div className="ms-sidebar">
        {[
          { key: "overview", icon: <Icons.Grid />, label: "Visão Geral" },
          { key: "my-equips", icon: <Icons.Laser />, label: "Meus Equipamentos" },
          { key: "rentals", icon: <Icons.Calendar />, label: "Locações" },
          { key: "courses", icon: <Icons.Book />, label: "Meus Cursos" },
          { key: "sales", icon: <Icons.Cart />, label: "Minhas Vendas" },
          { key: "certs", icon: <Icons.Award />, label: "Certificações" },
          { key: "earnings", icon: <Icons.DollarSign />, label: "Financeiro" },
        ].map(item => (
          <button key={item.key} className={`ms-sidebar-item ${sidebarItem === item.key ? "active" : ""}`} onClick={() => setSidebarItem(item.key)}>
            {item.icon} {item.label}
          </button>
        ))}
      </div>
      <div className="ms-main">
        <div className="ms-dash-header">
          <h2>Bem-vindo de volta, Dr. Rafael 👋</h2>
          <p>Aqui está o resumo da sua atividade na MedShare.</p>
        </div>
        <div className="ms-stat-cards">
          <div className="ms-stat-card">
            <div className="ms-stat-card-top">
              <span className="ms-stat-card-label">Receita do mês</span>
              <div className="ms-stat-card-icon teal"><Icons.DollarSign /></div>
            </div>
            <div className="ms-stat-card-value">R$12.450</div>
            <div className="ms-stat-card-change">↑ 23% vs mês anterior</div>
          </div>
          <div className="ms-stat-card">
            <div className="ms-stat-card-top">
              <span className="ms-stat-card-label">Locações ativas</span>
              <div className="ms-stat-card-icon purple"><Icons.Calendar /></div>
            </div>
            <div className="ms-stat-card-value">8</div>
            <div className="ms-stat-card-change">3 agendadas esta semana</div>
          </div>
          <div className="ms-stat-card">
            <div className="ms-stat-card-top">
              <span className="ms-stat-card-label">Cursos completos</span>
              <div className="ms-stat-card-icon amber"><Icons.Award /></div>
            </div>
            <div className="ms-stat-card-value">5</div>
            <div className="ms-stat-card-change">2 certificações ativas</div>
          </div>
          <div className="ms-stat-card">
            <div className="ms-stat-card-top">
              <span className="ms-stat-card-label">Avaliação média</span>
              <div className="ms-stat-card-icon blue"><Icons.Star filled /></div>
            </div>
            <div className="ms-stat-card-value">4.9</div>
            <div className="ms-stat-card-change">47 avaliações</div>
          </div>
        </div>

        {/* Recent Activity */}
        <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr", gap: "1.5rem" }}>
          <div style={{ background: "#fff", borderRadius: 18, padding: "1.5rem", border: "1px solid var(--slate-200)" }}>
            <h3 style={{ fontFamily: "var(--font-display)", fontWeight: 700, marginBottom: "1rem" }}>Próximas locações</h3>
            {[
              { equip: "GentleMax Pro Plus", who: "Dra. Camila Rocha", when: "Hoje, 14:00 — 17:00", status: "Confirmada" },
              { equip: "GentleMax Pro Plus", who: "Dr. Lucas Mendes", when: "Amanhã, 09:00 — 12:00", status: "Confirmada" },
              { equip: "Hollywood Spectra", who: "Dra. Ana Paula", when: "Qui, 10:00 — 13:00", status: "Pendente" },
            ].map((r, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: i < 2 ? "1px solid var(--slate-100)" : "none" }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>{r.equip}</div>
                  <div style={{ color: "var(--slate-400)", fontSize: "0.82rem" }}>{r.who} · {r.when}</div>
                </div>
                <span style={{
                  padding: "4px 12px", borderRadius: 100, fontSize: "0.72rem", fontWeight: 700,
                  background: r.status === "Confirmada" ? "rgba(5,150,105,0.1)" : "rgba(245,158,11,0.1)",
                  color: r.status === "Confirmada" ? "var(--emerald-600)" : "#d97706"
                }}>
                  {r.status}
                </span>
              </div>
            ))}
          </div>
          <div style={{ background: "#fff", borderRadius: 18, padding: "1.5rem", border: "1px solid var(--slate-200)" }}>
            <h3 style={{ fontFamily: "var(--font-display)", fontWeight: 700, marginBottom: "1rem" }}>Certificações</h3>
            {[
              { name: "Laser Alexandrite", status: "Ativa", color: "var(--emerald-600)" },
              { name: "Picossegundo", status: "Ativa", color: "var(--emerald-600)" },
              { name: "Lasers Vasculares", status: "Em andamento", color: "#d97706" },
            ].map((cert, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: i < 2 ? "1px solid var(--slate-100)" : "none" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 36, height: 36, borderRadius: 10, background: "var(--teal-50)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--teal-600)" }}>
                    <Icons.Award />
                  </div>
                  <span style={{ fontWeight: 600, fontSize: "0.9rem" }}>{cert.name}</span>
                </div>
                <span style={{ fontSize: "0.78rem", fontWeight: 700, color: cert.color }}>{cert.status}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// ===================== PROFILE PAGE =====================
const ProfilePage = ({ setPage }) => {
  const [tab, setTab] = useState("equips");
  return (
    <div className="ms-section fade-in">
      <div className="ms-profile-header">
        <div className="ms-profile-avatar">DR</div>
        <div>
          <h2 className="ms-profile-name">Dr. Rafael Mendonça</h2>
          <p className="ms-profile-specialty">Dermatologista · CRM 123456/SP</p>
          <div className="ms-profile-badges">
            <span className="ms-profile-badge-item"><Icons.Shield /> Verificado</span>
            <span className="ms-profile-badge-item"><Icons.Award /> 5 Certificações</span>
            <span className="ms-profile-badge-item"><Icons.Star filled /> 4.9 ★</span>
          </div>
        </div>
      </div>

      <div className="ms-profile-stats">
        <div className="ms-profile-stat-card">
          <div className="ms-profile-stat-value">3</div>
          <div className="ms-profile-stat-label">Equipamentos cadastrados</div>
        </div>
        <div className="ms-profile-stat-card">
          <div className="ms-profile-stat-value">47</div>
          <div className="ms-profile-stat-label">Locações realizadas</div>
        </div>
        <div className="ms-profile-stat-card">
          <div className="ms-profile-stat-value">5</div>
          <div className="ms-profile-stat-label">Cursos completos</div>
        </div>
        <div className="ms-profile-stat-card">
          <div className="ms-profile-stat-value">R$87k</div>
          <div className="ms-profile-stat-label">Total faturado</div>
        </div>
      </div>

      <div className="ms-tabs">
        {["equips","courses","reviews"].map(t => (
          <button key={t} className={`ms-tab ${tab === t ? "active" : ""}`} onClick={() => setTab(t)}>
            {{ equips: "Equipamentos", courses: "Cursos", reviews: "Avaliações" }[t]}
          </button>
        ))}
      </div>

      {tab === "equips" && (
        <div className="ms-card-grid">
          {equipments.slice(0, 3).map(eq => (
            <div key={eq.id} className="ms-equip-card" onClick={() => setPage("rental")}>
              <div className="ms-equip-card-img">
                <Icons.Laser />
                <span className={`ms-equip-card-badge ${eq.available ? "available" : "rented"}`}>
                  {eq.available ? "Disponível" : "Locado"}
                </span>
              </div>
              <div className="ms-equip-card-body">
                <div className="ms-equip-card-title">{eq.name}</div>
                <div className="ms-equip-card-subtitle"><Icons.MapPin /> {eq.location}</div>
                <div className="ms-equip-card-footer">
                  <div className="ms-equip-card-price">R${eq.price} <span>/{eq.period}</span></div>
                  <div className="ms-equip-card-rating"><Icons.Star filled /> {eq.rating}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === "courses" && (
        <div className="ms-card-grid">
          {courses.slice(0, 3).map(c => (
            <div key={c.id} className="ms-course-card">
              <div className={`ms-course-card-img ${c.color}`}>
                <div className="ms-course-card-play"><Icons.Play /></div>
                <div className="ms-course-card-level">{c.level}</div>
              </div>
              <div className="ms-course-card-body">
                <div className="ms-course-card-title">{c.title}</div>
                <div className="ms-course-card-instructor">{c.instructor}</div>
                <div style={{ marginTop: 12 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.8rem", color: "var(--slate-400)", marginBottom: 6 }}>
                    <span>Progresso</span><span>100%</span>
                  </div>
                  <div style={{ height: 6, background: "var(--slate-100)", borderRadius: 3 }}>
                    <div style={{ height: 6, background: "var(--teal-500)", borderRadius: 3, width: "100%" }} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === "reviews" && (
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {testimonials.map((t, i) => (
            <div key={i} style={{ background: "#fff", borderRadius: 16, padding: "1.5rem", border: "1px solid var(--slate-200)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.75rem" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: "var(--teal-50)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--teal-600)", fontWeight: 700, fontSize: "0.85rem" }}>
                    {t.initials}
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>{t.name}</div>
                    <div style={{ color: "var(--slate-400)", fontSize: "0.78rem" }}>{t.role}</div>
                  </div>
                </div>
                <StarRating rating={5} />
              </div>
              <p style={{ color: "var(--slate-600)", fontSize: "0.9rem", lineHeight: 1.7 }}>{t.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ===================== MAIN APP =====================
export default function MedShareApp() {
  const [page, setPage] = useState("landing");
  const [selectedEquip, setSelectedEquip] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const isLoggedIn = !["landing"].includes(page);

  useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, [page]);

  const renderPage = () => {
    switch (page) {
      case "landing": return <LandingPage setPage={setPage} />;
      case "rental": return <RentalPage setPage={setPage} setSelectedEquip={setSelectedEquip} />;
      case "equip-detail": return <EquipDetailPage equip={selectedEquip} setPage={setPage} />;
      case "courses": return <CoursesPage setPage={setPage} setSelectedCourse={setSelectedCourse} />;
      case "course-detail": return <CourseDetailPage course={selectedCourse} setPage={setPage} />;
      case "marketplace": return <MarketplacePage setPage={setPage} />;
      case "dashboard": return <DashboardPage setPage={setPage} />;
      case "profile": return <ProfilePage setPage={setPage} />;
      default: return <LandingPage setPage={setPage} />;
    }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="ms-app">
        <Navbar page={page} setPage={setPage} isLoggedIn={isLoggedIn} />
        {renderPage()}
      </div>
    </>
  );
}
